// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-13635f7f] {\n  transition: fill 0.3s;\n}", ""]);
// Exports
module.exports = exports;
